import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { AdminAccessFrame } from '../components/AdminAccessFrame';
import { useAuth } from '@edusense/shared-auth-core';
import { shouldAutoEnterAdminDashboard } from '../auth/adminMfaRouting';
import { startAdminPortalLogin } from '../auth/startAdminPortalLogin';
import { Button } from '../components/ui/button';
import { ADMIN_HOME_PATH } from '../navigation/adminNavigation';

export default function LandingPage() {
  const [searchParams] = useSearchParams();
  const isLogout = searchParams.get('logout') === 'true';
  const error = searchParams.get('error');
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    // 이미 로그인되어 있으면 기본 계정 화면으로 이동
    if (shouldAutoEnterAdminDashboard({
      isLoading,
      isAuthenticated,
      hasLoginError: Boolean(error),
      isLogout,
    })) {
      navigate(ADMIN_HOME_PATH, { replace: true });
    }
  }, [error, isAuthenticated, isLoading, isLogout, navigate]);

  const initiateLogin = () => {
    try {
      startAdminPortalLogin();
    } catch (err) {
      console.error('Failed to start login:', err);
    }
  };

  return (
    <AdminAccessFrame step={1}>
      <div className="space-y-7">
        <div className="space-y-3">
          <h1 className="text-3xl font-semibold tracking-tight">관리자 로그인</h1>
          <p className="text-sm leading-6 text-muted-foreground">UGOT Admin Portal에 로그인하고<br className="hidden sm:block" /> 서비스 운영을 이어가세요.</p>
        </div>
        {error || isLogout ? (
          <p role={error ? 'alert' : 'status'} className={`rounded-lg border px-4 py-3 text-sm leading-6 ${error ? 'border-destructive/25 bg-destructive/5 text-destructive' : 'border-emerald-200 bg-emerald-50 text-emerald-800'}`}>
            {error ? '로그인 처리 중 오류가 발생했거나 권한이 없습니다.' : '성공적으로 로그아웃 되었습니다.'}
          </p>
        ) : null}
        <Button onClick={initiateLogin} disabled={isLoading} className="h-12 w-full justify-between px-4 text-sm font-semibold">
          {isLoading ? '로그인 상태 확인 중...' : '관리자 계정으로 로그인'}
          <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Button>
        <p className="text-xs leading-6 text-muted-foreground">계정 로그인 후 인증 앱의 코드로 관리자 세션을 확인합니다.</p>
      </div>
    </AdminAccessFrame>
  );
}
